angular.module 'zc.core'

.factory 'PageLayout', () ->
  showFooter: false



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/page_layout.service.coffee